import { render, staticRenderFns } from "./LoginConfirmationForm.vue?vue&type=template&id=26f22b90&scoped=true&"
import script from "./LoginConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./LoginConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f22b90",
  null
  
)

export default component.exports